import React from "react";
import { Text, View, Image, Pressable } from "react-native";

import { getCommonDateTime } from "../services/DateTimeUtils";
import { extendOMSOrderData } from "../services/ExtendedDataUtils";
import { getImagePath, getPuralStringWithCount } from "../../utils/services/CommonUtils";
import { MoengageEvents, trackMoengageEvents } from "../services/webapp-services/MoengageUtils";
import { getOrderItemsString, isRateOrderAllowed, isReorderAllowed } from "../services/oms/OMSUtils";

import { CommonCTA, CommonIconCTA, PrimaryCTA } from "./CommonCTA";
import { CommonRightChevronIcon, HorizontalDivider } from "./Common-Widget";

import { OrderStatus } from "../constants/oms/OrderStatus";
import { ScreenRoute } from "../constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../constants/AppColors";

const OrderListCardView = (props) => {
    const index = props.index
    const orderData = extendOMSOrderData(props.orderData)
    const reorder = props?.reorder
    const rateOrder = props?.rateOrder

    const updateMessageCount = props.updateMessageCount
    const setSelectedOrderData = props.setSelectedOrderData

    const getMessageCTATitle = (orderData) => {
        if (orderData['orderStatus'] == OrderStatus.received)
            return 'Proceed to pay'
        else if (orderData['pharmacyData']['unreadMsgCount'] > 0)
            return getPuralStringWithCount(
                orderData['pharmacyData']['unreadMsgCount'], 'Message', 'Messages')
        else return 'Send Message'
    }

    return (<View key={'order_view_' + orderData['oid']}
        style={[AppStyles.borderView, AppStyles.bgWhite, AppStyles.lightShadow,
        AppStyles.mt16, AppStyles.p16, { width: AppTheme.appWidth - 32 }]}>
        <View style={[AppStyles.flexRowStart]}>
            <Image source={{
                uri: getImagePath(orderData['statusIcon']),
                width: 32, height: 32
            }} style={{ marginRight: 8 }} />
            <Text style={[TextStyle.text14b,
            { color: orderData['statusColor'] }]}>
                {orderData['title']}</Text>
        </View>

        <HorizontalDivider width={AppTheme.appWidth - 64} marginVertical={16} />

        {orderData['isCancelOrder'] ? <Pressable onPress={() => {
            props.navigation.navigate(ScreenRoute.view_order_summary,
                { orderData: orderData })
        }} style={[AppStyles.flexRowSpaceBetween]}>
            <Text style={[TextStyle.text16b]}>
                Order #{orderData['oid']}</Text>
            {CommonRightChevronIcon('black')}
        </Pressable> : <View>
            <Text style={[TextStyle.text10xb,
            { color: AppTheme.color.grey.fillerInfo }]}>
                Items</Text>
            <Pressable style={[AppStyles.flexRowSpaceBetween,
            { marginTop: 4, }]} onPress={() => {
                props.navigation.navigate(
                    ScreenRoute.view_order_summary,
                    { orderData: orderData })
            }}><Text style={[TextStyle.text14, {
                width: AppTheme.appWidth - 80
            }]} numberOfLines={2}>{getOrderItemsString(orderData)}</Text>
                {CommonRightChevronIcon('black')}
            </Pressable>
        </View>}

        <View style={{ marginTop: 16 }}>
            <Text style={[TextStyle.text10xb,
            { color: AppTheme.color.grey.fillerInfo }]}>
                Ordered on</Text>
            <Text style={[TextStyle.text14, { marginTop: 4 }]}>
                {getCommonDateTime(orderData['ts'])}</Text>
        </View>

        {orderData['isCancelOrder'] ? null : <View>
            {
                orderData['isActiveOrder'] ? <View>
                    <HorizontalDivider
                        width={AppTheme.appWidth - 64}
                        marginVertical={16} />
                    {
                        orderData['pharmacyData']['unreadMsgCount'] > 0 ?
                            <PrimaryCTA onPress={() => {
                                updateMessageCount(orderData, index)
                                trackMoengageEvents(MoengageEvents.oms_chat_opened,
                                    { pharmacyId: orderData['pharmacyData']['id'] })
                                props.navigation.navigate(ScreenRoute.oms_message_view,
                                    { orderData: orderData })
                            }} title={getMessageCTATitle(orderData)}
                                paddingVertical={8} width={AppTheme.appWidth - 64}
                            /> : <CommonCTA onPress={() => {
                                trackMoengageEvents(MoengageEvents.oms_chat_opened,
                                    { pharmacyId: orderData['pharmacyData']['id'] })
                                props.navigation.navigate(ScreenRoute.oms_message_view,
                                    { orderData: orderData })
                            }} title={getMessageCTATitle(orderData)}
                                backgroundColor={AppTheme.color.background}
                                paddingVertical={8} width={AppTheme.appWidth - 64}
                            />
                    }
                </View> : <View>
                    {isReorderAllowed(orderData) ||
                        isRateOrderAllowed(orderData) ?
                        <View>
                            <HorizontalDivider marginVertical={16}
                                width={AppTheme.appWidth - 64} />
                            {// check if CTA is allowed or not.
                                isReorderAllowed(orderData) &&
                                    isRateOrderAllowed(orderData) ?
                                    // check if both CTA is allowed.
                                    <View style={[AppStyles.flexRowSpaceBetween]}>
                                        <CommonIconCTA title={'Reorder'} icon={'reorder_blue.svg'}
                                            iconSize={24} width={AppTheme.appWidth / 2 - 40}
                                            paddingVertical={4} imageTextGap={8} backgroundColor={Colors.background}
                                            action={() => { reorder(orderData); setSelectedOrderData(orderData) }} />
                                        <CommonIconCTA title={'Rate It'} icon={'rate_blue.svg'}
                                            paddingVertical={6} imageTextGap={8} borderWidth={2}
                                            iconWidth={16.3} iconHeight={15.6} width={AppTheme.appWidth / 2 - 40}
                                            action={() => { rateOrder(orderData); setSelectedOrderData(orderData) }} />
                                    </View> :

                                    isRateOrderAllowed(orderData) ?
                                        // Handled each CTA individually
                                        <CommonIconCTA title={'Rate It'} icon={'rate_blue.svg'}
                                            paddingVertical={6} imageTextGap={8} borderWidth={2}
                                            iconWidth={16.3} iconHeight={15.6} width={AppTheme.appWidth - 64}
                                            action={() => { rateOrder(orderData); setSelectedOrderData(orderData) }} /> :

                                        isReorderAllowed(orderData) ?
                                            // Handled each CTA individually
                                            <CommonIconCTA title={'Reorder'} icon={'reorder_blue.svg'}
                                                iconSize={24} width={AppTheme.appWidth - 64}
                                                paddingVertical={4} imageTextGap={8} backgroundColor={Colors.background}
                                                action={() => { reorder(orderData); setSelectedOrderData(orderData) }} /> : null
                            }
                        </View> : null
                    }
                </View>
            }
        </View>}
    </View>
    )
}

export default OrderListCardView